import { QueryParams } from 'api/types/common.types';

export const queryKeys = {
  homePage: (params: QueryParams) => ['homePage', params] as const,
  widget: (id?: string) => ['widget', id] as const,
  homePageUpdateMutation: ['homePageUpdateMutation'] as const,
  homePageCreateMutation: ['homePageCreateMutation'] as const,
};
